import { useEffect, useRef } from 'react';
import type { ActionContext } from '../actions/actions';
import { Icon } from '../ui/icons';
import { insertTemplate } from './insertTemplate';
import { BOARD_TEMPLATES } from './templates';

export function TemplateGallery({ ctx, onClose }: { ctx: ActionContext; onClose: () => void }) {
  const dialogRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [onClose]);

  return (
    <div
      className="modal-backdrop"
      onMouseDown={(e) => {
        if (!dialogRef.current?.contains(e.target as Node)) onClose();
      }}
    >
      <div className="template-gallery" ref={dialogRef} role="dialog" aria-modal="true" aria-label="Шаблоны">
        <div className="template-gallery-head">
          <h2>Шаблоны</h2>
          <button type="button" className="icon-btn" aria-label="Закрыть" onClick={onClose}>
            <Icon name="close" size={16} />
          </button>
        </div>
        <div className="template-grid">
          {BOARD_TEMPLATES.map((t) => (
            <button
              key={t.id}
              type="button"
              className="template-card"
              onClick={() => {
                insertTemplate(ctx, t);
                onClose();
              }}
            >
              <span className="template-card-preview" style={{ background: t.accent }}>
                <Icon name="template" size={26} />
              </span>
              <span className="template-card-name">{t.name}</span>
              <span className="template-card-desc">{t.description}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
